import Glide from '@glidejs/glide';
import { ArrowControls, ArrowDisabler, ArrowResizer, CanSlide } from '../utils/_glide-plugins';
import { objectFit } from "../utils/_object-fit";
import { debounce } from '../utils/_debounce';

export default class PostSlider {

    constructor(wrapper, action = '', breakpoint = 0) {

        this.WRAPPER = wrapper;
        this.BREAKPOINT = breakpoint;
        this.SELECTOR_EL = this.WRAPPER.querySelector('.glide');
        if (!this.SELECTOR_EL) return;
        
        this.TOGGLES = this.WRAPPER.querySelectorAll('.mtt-post-loop-title-container__toggle');
        this.DIST = this.WRAPPER.querySelector('.mtt-post-loop__dist .glide__slides');
        this.LOADER = this.WRAPPER.querySelector('.mtt-post-loop__loader');
        this.SWIPE_ICONS = this.WRAPPER.querySelectorAll('.swipe-icon');
        
        this.has_large = this.WRAPPER.classList.contains('has-large');
        this.icons_hidden = false;
        this.slider_init = false;
        this.data = {
            'action': action
        };

        this.fillData();

        this.initSlider();
        this.toggleEventListeners();
    }

    toggleEventListeners() {
        if (!this.TOGGLES) {
            return;
        }

        for (let i = 0; i < this.TOGGLES.length; i++) {    
            const TOGGLE = this.TOGGLES[i];

            TOGGLE.addEventListener('click', () => {

                // set active toggle
                this.setActiveToggle(TOGGLE);

                // update cat
                this.data.cat = this.getAreaId(TOGGLE);

                // load posts
                this.loadPosts();

                // hide icons on click
                this.hideSwipeIcons();

            });
        }
    }

    setActiveToggle(toggle) {
        for (let i = 0; i < this.TOGGLES.length; i++) {
            this.TOGGLES[i].classList.remove('active');
        }
        toggle.classList.add('active');
    }

    getAreaId(el) {
        return el.getAttribute('data-area');
    }

    loadPosts() {

        this.showLoader();

        jQuery.post(main_theme_objects.ajax_url, this.data, (response) => {
            if (response != 0 && this.DIST) {

                // post markup
                this.DIST.innerHTML = response.markup;

                // run after
                objectFit();

                // destroy and remount
                this.destroySlider();
                this.initSlider();
                
                this.hideLoader();

            }
        });
    }

    fillData() {
        this.data.card_color = this.WRAPPER.classList.contains('mtt-post-loop--white') ? 'dark' : 'white';
        this.data.sort = this.WRAPPER.getAttribute('data-sort');
        this.data.larger_cards = this.WRAPPER.getAttribute('data-larger-cards');
        this.data.posts_per_page = this.WRAPPER.getAttribute('data-post-count');
    }

    initSlider() {

        // check init type
        if (!this.has_large) {
            this.createSlider()
        } else {
            this.checkForInit();
        }
    }

    // mount slider below bp, and destroy above bp
    checkForInit() {
        this.BREAKPOINT >= this.getScreenWidth() ? this.createSlider() : '';
        window.addEventListener('resize', debounce(() => {
            this.BREAKPOINT >= this.getScreenWidth() ? this.createSlider() : this.destroySlider();
        }, 300));
    }

    createSlider() {
        if (this.slider_init) {
            return;
        }

        // init slider
        this.SLIDER = new Glide(this.SELECTOR_EL, {
            type: 'slider',
            startAt: 0,
            perView: 4,
            gap: 32,
            animationDuration: 700,
            keyboard: false,
            bound: true,
            rewind: false,
            dragThreshold: 30,
            swipeThreshold: 50,
            peek: { before: 0, after: 0 },
            arrowClasses: {
                'back': 'slider-arrow--left',
                'next': 'slider-arrow--right',
                'disabled': 'slider-arrow--disabled'
            },
            breakpoints: {
                1350: {
                    perView: 3,
                    peek: { before: 0, after: 0 }
                },
                1100: {
                    perView: 2,
                    peek: { before: 0, after: 0 }
                },
                650: {
                    perView: 1,
                    peek: { before: 0, after: 0 }
                },
                // 700: {
                //     perView: 1,
                //     peek: { before: 0, after: 100 }
                // },
                // 500: {
                //     perView: 1,
                //     peek: { before: 0, after: 50 }
                // },
                400: {
                    perView: 1,
                    peek: { before: 0, after: 0 }
                },
            }
        });

        // mount slider
        this.SLIDER.mount({ ArrowControls, ArrowDisabler, ArrowResizer, CanSlide });

        // hide icons on swipe start
        this.SLIDER.on('swipe.start', this.hideSwipeIcons.bind(this));

        this.slider_init = true;
    }

    destroySlider() {
        if (!this.slider_init) {
            return;
        }

        this.SLIDER.destroy();

        this.slider_init = false;
    }

    showLoader() {
        if (!this.LOADER && !this.DIST) {
            return;
        }

        this.DIST.classList.add('loading');
        this.LOADER.classList.add('loader--show');
    }

    hideLoader() {
        if (!this.LOADER && !this.DIST) {
            return;
        }

        this.DIST.classList.remove('loading');
        this.LOADER.classList.remove('loader--show');
    }

    hideSwipeIcons() {
        if (!this.SWIPE_ICONS.length && this.icons_hidden) {
            return;
        }

        for (let i = 0; i < this.SWIPE_ICONS.length; i++) {
            this.SWIPE_ICONS[i].classList.add('swipe-icon--hide');
        }

        this.icons_hidden = true;
    }

    getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}